<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Billing Details</page-header>

        <team-billing-email
            :teamId="props.team.id"
            :billingEmail="props.billing.billing_email"
            :isEditable="isEditable"
        />

        <team-billing-info
            :teamId="props.team.id"
            :billingInformation="{
                billing_company_legal_name: props.billing.billing_company_legal_name,
                billing_address: props.billing.billing_address,
                billing_address_line_2: props.billing.billing_address_line_2,
                billing_city: props.billing.billing_city,
                billing_state: props.billing.billing_state,
                billing_zip: props.billing.billing_zip,
                billing_country: props.billing.billing_country,
                billing_po_number: props.billing.billing_po_number,
            }"
            :isEditable="isEditable"
            :hideCompanyLegalName="hideCompanyLegalName"
        />

        <team-stripe-payment-method
            v-if="isEditable && stripeKey"
            :teamId="props.team.id"
            :paymentMethod="{ card_brand: props.billing.card_brand, card_last_four: props.billing.card_last_four }"
            :stripeKey="stripeKey"
            :stripeApiVersion="stripeApiVersion"
        />
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import TeamBillingEmail from '~/components/settings/billing/TeamBillingEmail.vue';
import TeamBillingInfo from '~/components/settings/billing/TeamBillingInfo.vue';
import TeamStripePaymentMethod from '~/components/settings/billing/TeamStripePaymentMethod.vue';
import { computed } from 'vue';
import { isCompanyLegalNameHidden } from '~/utils/team';

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
    billing: {
        type: Object,
        required: true,
    },
});

const stripeKey = Spark.stripeKey;
const stripeApiVersion = Spark.stripeApiVersion;

const isEditable = computed(() => props.team.status !== 'closed');

const hideCompanyLegalName = computed(() => isCompanyLegalNameHidden(props.team.parent_id));
</script>
